export interface ProjectExample {
  name: string
  sector: string
  domain: string
  url: string
  description: string
  scope: string[]
}

export const projectExamples: ProjectExample[] = [
  {
    name: 'El Astillero',
    sector: 'Restaurante',
    domain: 'elastillero.rest',
    url: 'https://elastillero.rest',
    description:
      'Presencia web para un restaurante: identidad, carta digital y datos de contacto reunidos en un único sitio, pensado para consultarse cómodamente desde el móvil.',
    scope: ['Página web', 'Carta digital', 'Diseño responsive'],
  },
  {
    name: 'Trastienda Café',
    sector: 'Cafetería de barrio',
    domain: 'trastienda.cafe',
    url: 'https://trastienda.cafe',
    description:
      'Web para una cafetería de barrio: carta de churros, crepes, tostas y batidos, reserva de mesa y contacto, con una estética cálida fiel al propio local.',
    scope: ['Página web', 'Carta digital', 'Reserva de mesa'],
  },
]
